import { fallbackRestUrl } from "./path";
import axios from 'axios';
const API_URL = process.env.REST_URL || fallbackRestUrl;
// const FetchFileService = async (url: any, method = 'GET', variables: File | null = null, type: any = null) => {
//   try {
//     const headers: any = {};

//     if (type) headers['Content-Type'] = type;

//     const data = await fetch(`${url}`, {
//       headers,
//       method: method,
//       body: variables,
//     });

//     return { ok: true, data };
//   } catch (err: any) {
//     throw new Error(JSON.stringify(err?.response?.data) || '');
//   }
// };

// export default FetchFileService;

export const verifyFile = async (fileKey: string, token: string) => {
  const response = await fetch(`${API_URL}/file/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ file: fileKey }),
  });

  const data = await response.json();
  return data?.result?.success;
};



const FetchFileService = async (
  url: string,
  method = 'GET',
  variables: File | Blob | null = null,
  type: string | null = null,
  onProgress?: (percent: number, loaded: number, total: number) => void
) => {
  const retries = 3;
  let attempt = 0;

  while (attempt <= retries) {
    try {
      // 🔹 Use Axios for PUT uploads so we can surface progress
      
if (method === 'PUT' && variables) {
  const blob = variables as Blob;
  const res = await new Promise<{ ok: boolean; status: number }>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true);

    // ⚠️ Only set Content-Type if your presign includes it
    if (type) xhr.setRequestHeader('Content-Type', type);

    xhr.upload.onprogress = (evt) => {
      const total = (evt.lengthComputable && evt.total) ? evt.total : (blob?.size ?? 0);
      if (total > 0 && onProgress) {
        const raw = (evt.loaded / total) * 100;
        const pct = raw > 0 && raw < 1 ? 1 : Math.floor(raw); // avoid “stuck at 0”
        onProgress(pct, evt.loaded, total);
      }
    };

    xhr.onload = () => {
      // Emit a final 100 tick even if browser didn’t send one
      onProgress?.(100, blob.size ?? 0, blob.size ?? 0);
      if (xhr.status >= 200 && xhr.status < 300) resolve({ ok: true, status: xhr.status });
      else reject(new Error(`S3 PUT failed: ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('Network error during S3 PUT'));

    xhr.send(blob);
  });

  return { ok: res.ok, data: { status: res.status } as any };
}


      // 🔹 Everything else keeps your original fetch + retries
      const headers: Record<string, string> = {};
      if (type) headers['Content-Type'] = type;

      const response = await fetch(url, {
        headers,
        method,
        body: variables as any,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return { ok: true, data: response };
    } catch (err: any) {
      attempt++;
      console.warn(`Attempt ${attempt} failed: ${err.message || err}`);

      if (attempt > retries) {
        console.error('All retry attempts failed');
        throw new Error(
          JSON.stringify(err?.response?.data) || 'FetchFileService failed after all attempts'
        );
      }
    }
  }

  throw new Error('Unexpected error');
};

export default FetchFileService;

